module.exports = __webpack_public_path__ + "static/media/numb_thumb_logo.91d6c245.png";